import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { API_RESPONSE, COMMON_CONSTANTS, DIALOG_CONSTANT, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS, STORAGE_KEYS, TOASTER_CONFIGS } from "../../../../Utilities/Constants/Constants";
import "./BookingsListView.scss";
import { useState, useEffect } from "react";
import { GetSessionStorageData, checkEmpty, nullUndefinedEmptyCheck } from "../../../../Services/Helpers/Helper";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Switch, Pagination, Tooltip } from "@mui/material";
import NoDataFound from "../../../../Shared/NoDataFound/NoDataFound";
import moment from "moment";
import VideocamIcon from '@mui/icons-material/Videocam';
import BackArrow from "../../../../../Assets/schools/back_button.svg";
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationDialog from "../../../../Shared/ConfirmationDialog/ConfirmationDialog";
import ReasonDialog from "../../../../Shared/ReasonDialog/ReasonDialog";
import { toast } from "react-toastify";
import FeedbackIcon from '@mui/icons-material/Feedback';
import RatingsModal from "../RatingsModal/RatingsModal";
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import RescheduleList from "../../../../Shared/RescheduleList/RescheduleList";

const BookingsListView = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const { id } = useParams();
  const navigate = useNavigate();
  const [roleId, setRoleId] = useState("");
  const [myEventsList, setMyEventsList] = useState<any>([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalCount] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(10);
  const [hasProducts, setHasProducts] = useState(API_RESPONSE.FALSE);
  const [dialogContent, setDialogContent] = useState(DIALOG_CONSTANT.CANCEL_SLOT);
  const [dialogTitle, setDialogTitle] = useState(DIALOG_CONSTANT.CANCEL_SLOT_TITLE);
  const [cancelstatus, setCancelstatus] = useState(true)
  const [modalStatus, setmodalStatus] = useState(false);
  const [dialogOpenStatus, setDialogOpenStatus] = useState(API_RESPONSE.FALSE);
  const [currentIndex, setCurrentIndex] = useState(-1)
  const [rescheduleList, setRescheduleList] = useState<any>({ startDate: {}, sessionId: {} })

  const [ratingModalState, setRatingModalState] = useState(API_RESPONSE.FALSE);
  const [ratingModalContent, setRatingModalContent] = useState("");

  let IntialData = { state: false, session_id: "", startTime: "", endTime: "" }

  const [listModal, setListModal] = useState<any>(IntialData)

  /* Getting Role Id from session storage */
  useEffect(() => {
    moment.locale('en')
    setRoleId(GetSessionStorageData(STORAGE_KEYS.ROLE) || "");
  }, []);

  /* Calling booking detail api on role id update */
  useEffect(() => {
    if (roleId) getBookingData();
  }, [roleId, page, rowPerPage]);

  /**Handle row per page change */
  const onRowChange = (event: any) => {
    setRowPerPage(parseInt(event.target.value));
  };

  const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
    setPage(newPage);
  };

  /* Booking detail API call */
  const getBookingData = () => {
    let payload = {
      service_provider_id: id,
      teach_service_provider:
        roleId == `${NUMBER_CONSTANTS.FOUR}`
          ? NUMBER_CONSTANTS.ONE
          : roleId == `${NUMBER_CONSTANTS.NINE}`
            ? NUMBER_CONSTANTS.TWO
            : NUMBER_CONSTANTS.THREE,
    };
    axiosInstance
      .post(API_END_POINTS.BOOKING_DETAILS, payload)
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          setMyEventsList(response.data.result.data);
          setTotalCount(response.data.result.total_page);
          setHasProducts(checkEmpty(response.data.result.data));
        }
      })
      .catch(() => { })
  };

  const checkEnableTime = (timing: any) => {
    const currentTime = new Date(); // Current time
    const startTime = new Date(timing.start); // Replace with your actual start time
    // Calculate the timestamp for 5 minutes before the start time
    const fiveMinutesBeforeStartTime = new Date(startTime.getTime() - NUMBER_CONSTANTS.FIFTEEN * NUMBER_CONSTANTS.SIXTY * NUMBER_CONSTANTS.THOUSAND);

    // Check if the current time is less than 5 minutes before the start time
    if (currentTime >= fiveMinutesBeforeStartTime) {
      return true;
    } else {
      return false;
    }
  };

  const enableAttendence = (data: any) => {
    axiosInstance
      .put(API_END_POINTS.ENABLE_ATTENDENCE, {
        "session_time_slot_id": data.id,
        "session_slot_id": data.session_slot,
      })
      .then((response: any) => {
        if (response.data.status === API_RESPONSE.TRUE) {
          // toast.success(response.data.message, TOASTER_CONFIGS);
          window.open(data?.meet_link, '_blank')
        }
      });

  };

  const onActivateDeactivate = (status: any) => {
    if (status === API_RESPONSE.TRUE) {
      setDialogOpenStatus(API_RESPONSE.TRUE);
    }
    setmodalStatus(API_RESPONSE.FALSE);
  };

  const onCloseDialog = () => {
    // setCurrentIndex(null);
    setDialogOpenStatus(API_RESPONSE.FALSE);
  };
  const onCloseFeedbackDialog = () => {
    // setCurrentIndex(null);
    setRatingModalContent("");
    setRatingModalState(API_RESPONSE.FALSE);
  };

  /** update reason for blocking the recreational user */
  const onSubmitReason = (value: any, index: number) => {

    if (currentIndex !== -1) {
      let payload = {
        booking_id: myEventsList[currentIndex]?.booking_id,
        booked_time_slot_id: myEventsList[currentIndex]?.booked_time_slot_id,
        reason: value.reason
      };
      let reschedulePayload = {
        booking_id: myEventsList[currentIndex]?.booking_id,
        booked_time_slot_id: myEventsList[currentIndex]?.booked_time_slot_id,
        teach_service_provider_id: myEventsList[currentIndex]?.teach_service_provider_id?.toString(),
        user_id: myEventsList[currentIndex]?.user_id,
        meet_link: myEventsList[currentIndex]?.meet_link,
        reason: value.reason,
        session_time_slot_id: rescheduleList?.sessionId?.id?.toString(),
        booked_slot_detail: [{
          avail_time_slot_ids: rescheduleList?.sessionId?.id,
          session_title: myEventsList[currentIndex]?.title,
          slot_price: myEventsList[currentIndex]?.slot_price,
          start_date: moment(rescheduleList?.startDate?.startDate).format(COMMON_CONSTANTS.YMD_FORMAT),
          start_time: myEventsList[currentIndex]?.start_time,
          end_time: myEventsList[currentIndex]?.end_time,
          session_slot_id: rescheduleList?.sessionId?.sessionSlotId,
          session_id: rescheduleList?.sessionId?.session_id
        }]

      }
      cancelstatus ?
        axiosInstance.post(API_END_POINTS.TUTOR_CANCEL_SLOT, payload).then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            getBookingData();
          }
        })
        : axiosInstance.put(API_END_POINTS.RESHEDULE_SLOT, reschedulePayload).then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            toast.success(response.data.message, TOASTER_CONFIGS);
            getBookingData();
          }
        })
    }
    setDialogOpenStatus(false);
    // deleteApiCall(index,value)
  };

  useEffect(() => {
    if (/* ratingModalContent !== null ||  */ratingModalContent !== "") {
      setRatingModalState(API_RESPONSE.TRUE)
    }
  }, [ratingModalContent])
  const handleClose = () => {
    setListModal({ state: false, session_id: "", startTime: "", endTime: "" })

  }
  const handleSubmit = (values: any, data: any) => {
    setmodalStatus(API_RESPONSE.TRUE)
    setListModal({ state: false, session_id: "", startTime: "", endTime: "" })
    setRescheduleList({ startDate: values, sessionId: data })

  }
  return (
    <div className="bookings-listview-wrapper">
      <div className="arrow-wrap">
        <img
          alt="Learn and Play"
          src={BackArrow}
          className="EditSchool-backarrow"
          onClick={() => {
            navigate(-1);
          }}
        />
        <h5 className="name-title ms-2">{t("Bookings Detail")}</h5>
      </div>

      <div className="table-wrapper">

        <div className="basic-detail-wrapper">
          <div className="row">
            <div className="col-md-6">

            </div>
          </div>
        </div>
        <ConfirmationDialog
          content={dialogContent}
          modalState={modalStatus}
          dialogStatus={onActivateDeactivate}
        />

        <ReasonDialog
          modalState={dialogOpenStatus}
          dialogStatus={onCloseDialog}
          submitReason={onSubmitReason}
          title={dialogTitle}
          id={currentIndex}
        />

        <RatingsModal
          modalState={ratingModalState}
          content={ratingModalContent}
          dialogStatus={onCloseFeedbackDialog}
        />
        <RescheduleList modalOpen={listModal}
          handleClose={handleClose}
          handleSubmit={handleSubmit} />


        {GetSessionStorageData(STORAGE_KEYS.ROLE) == `${NUMBER_CONSTANTS.FIVE}` ? (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("S.NO")}</TableCell>
                  <TableCell>{t("Email")}</TableCell>
                  <TableCell>{t("Mobile Number")}</TableCell>
                  <TableCell>{t("Child")}</TableCell>
                  <TableCell>{t("Actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {myEventsList.map((expertData: any, index: any) => {
                  return (
                    <>
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{expertData.booked_email}</TableCell>
                        <TableCell>{expertData.booked_phone_number}</TableCell>
                        <TableCell>{expertData.child_name}</TableCell>
                        <TableCell className="action-items">
                          <Tooltip title="Student feedback">
                            <FeedbackIcon className={expertData.feedback ? 'enable-cancel' : 'disable-cancel'}
                              onClick={() => {
                                if (expertData.feedback)
                                  setRatingModalContent(expertData)

                              }}
                            />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
            {!hasProducts && <NoDataFound />}
          </TableContainer>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t("S.NO")}</TableCell>
                  <TableCell>{t("Date")}</TableCell>
                  <TableCell className="cell-value">{t("Start Time")}</TableCell>
                  <TableCell className="cell-value">{t("End Time")}</TableCell>
                  <TableCell>{t("Student")}</TableCell>
                  {
                    roleId === `${NUMBER_CONSTANTS.FOUR || NUMBER_CONSTANTS.NINE}` &&
                    <TableCell>{t("Address")}</TableCell>
                  }

                  {roleId === `${NUMBER_CONSTANTS.FOUR}` && myEventsList[0]?.course_mode === "Online" && <TableCell className="cell-value">{t("Video Link")}</TableCell>}
                  <TableCell className="cell-value">{t("Slot Price")}</TableCell>
                  {roleId === `${NUMBER_CONSTANTS.FOUR}` && <TableCell className="cell-value">{t("Student Availability Status")}</TableCell>}
                  <TableCell className="cell-value">{t("Cancelation Request Status")}</TableCell>
                  <TableCell className="cell-value">{t("Cancelation Reason")}</TableCell>
                  <TableCell>{t("Actions")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {myEventsList.map((expertData: any, index: any) => {

                  return (
                    <>
                      <TableRow key={index + 1}>
                        <TableCell className="cell-value" key={index}>{index + 1}</TableCell>
                        <TableCell className="cell-value" key={index}>{moment(expertData.start).format(COMMON_CONSTANTS.DMY_FORMAT)}</TableCell>
                        <TableCell className="cell-value" key={index}>{moment(expertData.start).format(COMMON_CONSTANTS.HMA_FORMAT)}</TableCell>
                        <TableCell className="cell-value" key={index}>{moment(expertData.end).format(COMMON_CONSTANTS.HMA_FORMAT)}</TableCell>
                        <TableCell className="cell-value" key={index}>{expertData.username}</TableCell>
                        {roleId === `${NUMBER_CONSTANTS.FOUR || NUMBER_CONSTANTS.NINE}` && (
                          <TableCell className="cell-value" key={index}>
                            {expertData?.user_address && (() => {
                              const addressText = `${expertData?.user_address?.map_address},${expertData?.user_address?.address},${expertData?.user_address?.state}`;

                              return addressText.length > 10 ? (
                                <Tooltip title={addressText} placement="top-start">
                                  <p className="mb-0" style={{ whiteSpace: "nowrap", textTransform: "none" }}>
                                    {`${addressText?.slice(0, 15)}..`}
                                  </p>
                                </Tooltip>
                              ) : (
                                <p>{addressText}</p>
                              );
                            })()}
                          </TableCell>
                        )}
                        {roleId === `${NUMBER_CONSTANTS.FOUR}` && expertData.course_mode === "Online" && <TableCell>
                          {/* {roleId === `${NUMBER_CONSTANTS.FOUR}` && expertData.course_mode === "Online" && checkEnableTime(expertData) && moment(new Date(expertData.start)).format(COMMON_CONSTANTS.YMD_FORMAT)===moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) && <VideocamIcon  onClick={() => enableAttendence(expertData)} />}
                          {roleId === `${NUMBER_CONSTANTS.FOUR}` && expertData.course_mode === "Online" && checkEnableTime(expertData) && moment(new Date(expertData.start)).format(COMMON_CONSTANTS.YMD_FORMAT) !==moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) && <VideocamIcon className="disable-cancel" />}
                          {roleId === `${NUMBER_CONSTANTS.FOUR}` && expertData.course_mode === "Online" && !checkEnableTime(expertData) && <>N/A</>}
                           */}
                          {roleId === `${NUMBER_CONSTANTS.FOUR}` /* && expertData.is_meet_link */ && <VideocamIcon className={expertData.is_meet_link ? "enable-cancel" : "disable-cancel"} onClick={() => {
                            if (expertData.is_meet_link)
                              enableAttendence(expertData)
                          }} />}

                        </TableCell>}
                        <TableCell className="cell-value" key={index}>{t(expertData.slot_price)}</TableCell>
                        {roleId === `${NUMBER_CONSTANTS.FOUR}` && <TableCell className="cell-value" key={index}>{t(expertData.is_didnot ? (moment(new Date(expertData.start)).format(COMMON_CONSTANTS.YMD_FORMAT) < moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) ? 'Did not attend' : 'Will not attend') : moment(new Date(expertData.start)).format(COMMON_CONSTANTS.YMD_FORMAT) < moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT) ? 'Attended' : 'Will attend')}</TableCell>}
                        <TableCell className="cell-value" key={index}>
                          {expertData.cancel_status}
                        </TableCell>

                        <TableCell>{expertData.reason ? expertData.reason : 'N/A'}</TableCell>
                        <TableCell className="action-items">
                          <Tooltip title="Reschedule">
                            <EventRepeatIcon style={{ marginRight: "10px" }} className={(new Date(expertData.start) >= new Date() && (expertData.cancel_status === "not requested" || expertData.cancel_status === "rejected")) ? 'enable-cancel' : 'disable-cancel'}
                              onClick={() => {
                                if (new Date(expertData.start) > new Date()) {
                                  setCurrentIndex(index);
                                  // setmodalStatus(API_RESPONSE.TRUE)
                                  setListModal({
                                    state: true, session_id: expertData?.service_provider_id, startTime: expertData?.
                                      start_time, endTime: expertData?.end_time
                                  })
                                  setDialogContent(DIALOG_CONSTANT.RESHEDULE_SLOT)
                                  setDialogTitle(DIALOG_CONSTANT.RESHEDULE_SLOT_TITLE)
                                  setCancelstatus(false)

                                }
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Cancel Slot">
                            <>
                              <CancelIcon style={{ marginRight: "10px" }} className={(new Date(expertData.start) >= new Date() && (expertData.cancel_status === "not requested" || expertData.cancel_status === "rejected")) ? 'enable-cancel' : 'disable-cancel'} onClick={() => {
                                if (new Date(expertData.start) > new Date()) {
                                  setCurrentIndex(index);
                                  setmodalStatus(API_RESPONSE.TRUE)
                                  setDialogContent(DIALOG_CONSTANT.CANCEL_SLOT)
                                  setDialogTitle(DIALOG_CONSTANT.CANCEL_SLOT_TITLE)
                                  setCancelstatus(true)
                                }
                              }} />
                            </>
                          </Tooltip>
                          <Tooltip title="Student feedback">
                            <FeedbackIcon className={expertData.feedback ? 'enable-cancel' : 'disable-cancel'}
                              onClick={() => {
                                if (expertData.feedback)
                                  setRatingModalContent(expertData)

                              }}
                            />
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>
            </Table>
            {!hasProducts && <NoDataFound />}
          </TableContainer>
        )}
        {hasProducts && (
          <div className="tablePagination">
            <div className="row">
              <div className="col-md-7">
                <div className="pagination-wrap">
                  <Pagination
                    count={totalPage}
                    page={page}
                    onChange={handleChangePage}
                  />
                </div>
              </div>
              <div className="col-md-5">
                <div className="rows-per-page">
                  <p>{t("Rows per page")}:</p>
                  <select
                    className="rows-select"
                    value={rowPerPage}
                    onChange={onRowChange}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
};

export default BookingsListView;